export const CAN_ASSIGN_LEARNER_STUDENT_TO_OTHERS = 'AC-2310-UL-001'
export const CAN_VIEW_ALL_GOALS_OF_LEARNER = 'AC-2310-UL-002'
export const CAN_EDIT_DELETE_ALL_GOALS_OF_LEARNER = 'AC-2310-UL-003'
export const CAN_RUN_ALL_ACTIVITIES_OF_LEARNER = 'AC-2310-UUL-004' 

 